import React, {Component, Fragment} from 'react';
import { connect } from "react-redux";
import UnlockCalculationsSteps from "./unlockCalculationsSteps";
import {setShowUnlockCalculations, setShowUnlockCalculationsTutorial} from "../../actions/unlockCalculationsFunctions";
import UnlockCalculationsTutorial from "./unlockCalculationsTutorial";
import UnlockCalculationsTutorialLowes from "./unlockCalculationsTutorialLowes";

class UnlockCalculations extends Component {

  overlayElement = null;
  _isMounted = false;

  componentDidMount() {
    const {fabricatorData, isPhoneNumberValidated, cartItems, instList} = this.props;
    if (fabricatorData.settings.leadCaptureShoppingCart) {
      if (!isPhoneNumberValidated) { // not logged in
        if (cartItems.length || instList.length) {
          this.props.setShowUnlockCalculations(true);
        }
      } else {
        if (this.props.showUnlockCalculations) {
          this.props.setShowUnlockCalculations(false);
        }
        if (!this.props.unlockCalculationsTutorialIsFinished) {
          this.props.setShowUnlockCalculationsTutorial(true);
        }
      }
    }
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.fabricatorData.settings.leadCaptureShoppingCart && !this.props.unlockCalculationsTutorialIsFinished
      && nextProps.isPhoneNumberValidated && !this.props.isPhoneNumberValidated) {
      setTimeout(() => {
        if (this._isMounted && !this.props.isPhoneNumberValidated) {
          this.props.setShowUnlockCalculations(false);
          if (!this.props.orderCompletePopupVisible) {
            this.props.setShowUnlockCalculationsTutorial(true);
          }
        }
      }, 5000)
    }
  }

  render() {
    return (
      <Fragment>
        {this.props.showUnlockCalculations ? <UnlockCalculationsSteps/> : null}
        {this.props.showUnlockCalculationsTutorial
          ? this.props.fabricatorData.isLowes
            ? <UnlockCalculationsTutorialLowes/>
            : <UnlockCalculationsTutorial/>
          : null}
      </Fragment>
    )
    // return this.props.showUnlockCalculations ? <UnlockCalculationsTutorial/> : null
  }
}

const mapStateToProps = (store) => {
  return {
    showUnlockCalculations: store.unlockCalculationsState.showUnlockCalculations,
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorData: store.fabricatorState,
    isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
    showUnlockCalculationsTutorial: store.unlockCalculationsState.showUnlockCalculationsTutorial,
    unlockCalculationsTutorialIsFinished: store.unlockCalculationsState.unlockCalculationsTutorialIsFinished,
    orderCompletePopupVisible: store.cartState.orderCompletePopupVisible,
  };
};

export default connect(mapStateToProps, {
  setShowUnlockCalculations,
  setShowUnlockCalculationsTutorial
})(UnlockCalculations);
